<template>
  <div class="approval-status" :data-testid="dataTestId">
    <!-- Metrics Only: SUB X/Y | APP X/Y -->
    <div class="approval-status__metrics" :data-testid="`${dataTestId}__metrics`">
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <div class="approval-status__metric" v-bind="attrs" v-on="on">
            <span class="approval-status__metric-label">SUB</span>
            <span class="approval-status__metric-value">{{ subApproved }}/{{ subTotal }}</span>
          </div>
        </template>
        <span>Submitted</span>
      </v-tooltip>
      <span class="approval-status__separator"></span>
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <div class="approval-status__metric" v-bind="attrs" v-on="on">
            <span class="approval-status__metric-label">APP</span>
            <span class="approval-status__metric-value">{{ appApproved }}/{{ appTotal }}</span>
          </div>
        </template>
        <span>Approved</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalStatus',

  props: {
    /**
     * Number of submitted items
     */
    subApproved: {
      type: Number,
      required: true,
    },

    /**
     * Total number of submitted items
     */
    subTotal: {
      type: Number,
      required: true,
    },

    /**
     * Number of approved items
     */
    appApproved: {
      type: Number,
      required: true,
    },

    /**
     * Total number of items for approval
     */
    appTotal: {
      type: Number,
      required: true,
    },

    /**
     * Base data-testid for testing
     */
    dataTestId: {
      type: String,
      default: 'approval-status',
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ApprovalStatus.scss';
</style>
